export * from './privacy-terms-page.component';
